module.exports = __webpack_public_path__ + "static/fonts/TrebuchetMS-Bold.fba8231.woff2";